export const settings = {
  _root: "/settings",
  general: "/general",
  inputs: "/inputs",
  logout: "/logout"
};
